import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import Loader from './component/common/Loader';
import { showNotification } from './action/NotificationAction';
import { PATH } from '../utils/Constants';
import { RESPONSE_CONSTANT } from '../utils/ResponseConstant';
import store from '../sessionStorage';
import { Student, Tutor } from '../utils/common/NamingTerms';
import {
    BRANCH_ADMIN_ROUTES_SECONDARY_PATH,
    INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH,
    LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH,
    LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH,
} from '../utils/routes/path';
import {
    addCleverLevel3Relation,
    getCleverLevel3List,
    getCleverLoginUserDetails,
    login,
} from './action/UserAction';
import { getSubCategoryList } from './action/Admin/CommonAction';
import { BYPASS_TOKEN, INS_BASE_REST_URL } from '../utils/URL';
import AppConfig from '../utils/common/DomainConfiguration';

class Login extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        showNotification: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            userInfo: null,
            cleverToken: '',
            userLoginInfo: {},
            showSchoolSelectionModal: false,
            schoolIds: [],
            selectedCategoryValue: [],
            schoolUpdated: false,
        };
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        this.callApi();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    callApi = async () => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const sessionId = urlParams.get('session_id');
            localStorage.setItem('bypassSessionId', sessionId);
            if (!sessionId) {
                throw new Error('Session ID not found in URL');
            }

            const response = await fetch(
                `${INS_BASE_REST_URL}${BYPASS_TOKEN}/${sessionId}`.trim(),
                {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-Method': 'cookie',
                    },
                }
            );
            const userInfo = await response.json();
            if (userInfo && userInfo.token && userInfo.token.value && userInfo.id) {
                const token = userInfo.token.value;
                store.set('bloomIfAI_id', userInfo.id);
                store.set('userSession', userInfo);

                // Persist language preference only for healthcare switcher flows.
                if (AppConfig.isHealthCare === true) {
                    if (userInfo.preferredLanguage) {
                        localStorage.setItem('preferredLanguage', userInfo.preferredLanguage);
                    }
                    if (userInfo.user_language) {
                        localStorage.setItem('user_language', userInfo.user_language);
                    }
                }

                if (this._isMounted) {
                    this.setState({ userInfo: userInfo, isLoading: false });
                    this.getCleverLoginUserDetails(token);
                }
            } else {
                throw new Error('Invalid API response');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            if (this._isMounted) {
                this.setState({ isLoading: false });
                this.props.showNotification('Error fetching data', RESPONSE_CONSTANT.ERROR);
            }
        }
    };

    getCleverLoginUserDetails = (cleverToken) => {
        let params = {
            cleverToken: cleverToken,
        };
        this.props.getCleverLoginUserDetails(params, (result) => {
            this.setState({ isLoading: false });
            if (result.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.props.showNotification(result.message, RESPONSE_CONSTANT.ERROR);
            } else {
                if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.navigateUserScreen(result);
                    this.setState({ userLoginInfo: result });
                } else {
                    this.props.showNotification('Username or Password Invalid', 'error');
                }
            }
        });
    };

    getCleverLevel3List = () => {
        this.setState({ isSchoolLoading: true });
        this.props.getCleverLevel3List((result) => {
            this.setState({ isSchoolLoading: false });
            if (result) {
                let optionList = [];
                result.response.forEach((element) => {
                    let obj = {
                        label: element.name,
                        value: element.institutionId,
                    };
                    optionList.push(obj);
                });
                this.setState({ options: optionList });
            }
        });
    };

    saveSchoolInfo = () => {
        let params = {};
        let institutionIds = [];
        let expertises = [];
        if (
            this.state.userLoginInfo &&
            this.state.userLoginInfo.response &&
            this.state.userLoginInfo.response.role === Tutor
        ) {
            if (this.state.schoolIds && !this.state.schoolIds.length) {
                this.props.showNotification(
                    'Please select at least one school',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (this.state.selectedCategoryValue && !this.state.selectedCategoryValue.length) {
                this.props.showNotification(
                    'Please select at least one Element',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (this.state.schoolIds && this.state.schoolIds.length) {
                this.state.schoolIds.forEach((element) => {
                    institutionIds.push(element.value);
                });
            }

            if (this.state.selectedCategoryValue) {
                this.state.selectedCategoryValue.map((data) => expertises.push(data.value));
            }
            params = {
                expertises,
            };
        } else {
            if (!this.state.schoolId) {
                this.props.showNotification(
                    'Please select at least one school',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            if (!this.state.studentRollNumber) {
                this.props.showNotification(
                    'Please enter Team Member roll number',
                    RESPONSE_CONSTANT.WARNING
                );
                return;
            }
            params = {
                studentRollNumber: this.state.studentRollNumber,
            };
            if (this.state.schoolId) {
                institutionIds.push(this.state.schoolId.value);
            }
        }
        params.institutionIds = institutionIds;
        this.setState({ saveSchoolInfoLoading: true });
        this.props.addCleverLevel3Relation(params, (userInfo) => {
            if (userInfo) {
                this.props.showNotification(userInfo.message, RESPONSE_CONSTANT.SUCCESS);
                this.setState({ saveSchoolInfoLoading: false });
                this.getCleverLoginUserDetails(this.state.cleverToken);
            }
        });
    };

    navigateUserScreen = (userInfo) => {
        const role = userInfo.response.role;
        if (role === Tutor) {
            if (!userInfo.response.institutionRelationFound && !this.state.schoolUpdated) {
                this.getCleverLevel3List();
                this.setState({ showSchoolSelectionModal: true, schoolUpdated: true });
            } else {
                if (userInfo.response.mailVerified === false) {
                    this.props.history.push({
                        pathname: `${PATH.IM_PHYSICIAN.VERIFY_EMAIL}/${userInfo.response.id}`,
                        state: { fromLogin: true },
                    });
                    return;
                } else if (userInfo.response.mustChangePassword === true) {
                    this.props.history.push(
                        `${PATH.IM_PHYSICIAN.CHANGE_PASSWORD}/${userInfo.response.id}`
                    );
                    return;
                } else {
                    // this.props.showNotification(
                    //   "Login successful",
                    //   RESPONSE_CONSTANT.SUCCESS
                    // );
                    this.props.history.push(
                        `${PATH.IM_PHYSICIAN.DASHBOARD}/${userInfo.response.id}`
                    );
                }
            }
        } else if (role === RESPONSE_CONSTANT.INSADMIN) {
            if (userInfo.response.mustChangePassword === true) {
                this.props.history.push(
                    `${INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH.INS_SUPER_ADMIN}${INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH.CHANGE_PASSWORD}/${userInfo.response.id}`
                );
                return;
            } else {
                // this.props.showNotification(
                //   "Login successful",
                //   RESPONSE_CONSTANT.SUCCESS
                // );
                this.props.history.push(
                    `${INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH.INS_SUPER_ADMIN}/${userInfo.response.id}${INS_SUPER_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                );
            }
        } else if (role === RESPONSE_CONSTANT.BRANCHADMIN) {
            if (userInfo.response.mustChangePassword === true) {
                this.props.history.push(
                    `${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.BRANCH_ADMIN}${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.CHANGE_PASSWORD}/${userInfo.response.id}`
                );
                return;
            } else {
                // this.props.showNotification(
                //   "Login successful",
                //   RESPONSE_CONSTANT.SUCCESS
                // );
                this.props.history.push(
                    `${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.BRANCH_ADMIN}/${userInfo.response.id}${BRANCH_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                );
            }
        } else if (role === RESPONSE_CONSTANT.LEVEL_ONE_ADMIN) {
            if (userInfo.response.mustChangePassword === true) {
                this.props.history.push(
                    `${LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_ONE_ADMIN}${LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH.CHANGE_PASSWORD}/${userInfo.response.id}`
                );
                return;
            } else {
                // this.props.showNotification(
                //   "Login successful",
                //   RESPONSE_CONSTANT.SUCCESS
                // );
                this.props.history.push(
                    `${LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_ONE_ADMIN}/${userInfo.response.id}${LEVEL_ONE_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                );
            }
        } else if (role === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN) {
            if (userInfo.response.mustChangePassword === true) {
                this.props.history.push(
                    `${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_TWO_ADMIN}${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.CHANGE_PASSWORD}/${userInfo.response.id}`
                );
                return;
            } else {
                // this.props.showNotification(
                //   "Login successful",
                //   RESPONSE_CONSTANT.SUCCESS
                // );
                this.props.history.push(
                    `${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_TWO_ADMIN}/${userInfo.response.id}${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.DASHBOARD}`
                );
            }
        } else if (userInfo.response.role === 'PARENT' || userInfo.response.role === Student) {
            if (!userInfo.response.institutionRelationFound && !this.state.schoolUpdated) {
                this.getCleverLevel3List();
                this.setState({ showSchoolSelectionModal: true, schoolUpdated: true });
            } else {
                if (userInfo.response.mustChangePassword === true) {
                    this.props.history.push(
                        `${PATH.IM_PATIENT.CHANGE_PASSWORD}/${userInfo.response.id}`
                    );
                    return;
                } else {
                    // this.props.showNotification(
                    //   "Login successful",
                    //   RESPONSE_CONSTANT.SUCCESS
                    // );
                    this.props.history.push(`${PATH.IM_PATIENT.DASHBOARD}/${userInfo.response.id}`);
                }
            }
        } else {
            this.props.showNotification('Username or Password Invalid', 'error');
        }
    };

    render() {
        return (
            <div className="fixed top-0 left-0 w-full h-full bg-UIBackground">
                <Loader />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.userReducer,
});

const mapDispatchToProps = (dispatch) => ({
    login: (values, callback) => {
        dispatch(login(values, callback));
    },
    getCleverLoginUserDetails: (params, callback) => {
        dispatch(getCleverLoginUserDetails(params, callback));
    },
    getCleverLevel3List: (callback) => {
        dispatch(getCleverLevel3List(callback));
    },
    getSubCategoryList: (values, callback) => {
        dispatch(getSubCategoryList(values, callback));
    },
    addCleverLevel3Relation: (values, callback) => {
        dispatch(addCleverLevel3Relation(values, callback));
    },
    showNotification: (message, type) => {
        dispatch(showNotification(message, type));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
